import type {
  GetUserHomeInfoUC,
  SessionClient,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";

export class GetUserHomeInfo implements GetUserHomeInfoUC {
  constructor(
    private readonly userRepo: UserRepository,
    private readonly sessionClient: SessionClient,
  ) {}

  async execute() {
    const res = await this.userRepo.getUserHomeInfo();
    this.sessionClient.updateSession({
      online: res.user.online,
      imediate: res.user.imediate,
    });
    return res;
  }
}
